import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { claimsAreSuperUser } from '@shared';
import { getClaims } from '@/lib/token';

export const Route = createFileRoute('/_authed/system')({
  beforeLoad: () => {
    const claims = getClaims();

    if (!claims || !claimsAreSuperUser(claims)) throw redirect({ to: '/' });
  },
  component: Outlet,
});
